import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import type {
  Column,
  ColumnsType,
} from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import TimeOffSidepanel from 'modules/shift_management/components/ShiftManagement/TimeOffSidepanel'

import TimeOffCell from './TimeOffCell'
import useGetTimeOffRow from './useGetTimeOffRow'

interface LeaveRowProps {
  columns: ColumnsType
}

const TimeOffRow = ({ columns }: LeaveRowProps) => {
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false)
  const [selectedDate, setSelectedDate] = useState<moment.Moment>(moment())

  const cells = columns.slice(1)

  const { leaves, restDays, holidays, loading } = useGetTimeOffRow({ skip: false })

  const handleClick = (date: moment.Moment) => {
    setSelectedDate(date)
    setIsSidePanelOpen(true)
  }

  return (
    <>
      <WrapperCell sticky minWidth="s240">
        <Box
          background="grey000White"
          flexDirection="row"
          justifyContent="spaceBetween"
          height="full"
          paddingY="s8"
          paddingX="s16"
        >
          <Box flexDirection="row" alignItems="center" overflowX="hidden">
            <Text size="300" weight="medium" color="grey1000" ellipsis>
              {i18n.t('shift_management.time_off_row.title')}
            </Text>
          </Box>
        </Box>
      </WrapperCell>

      {cells.map((column: Column, columnIndex: number) => {
        return (
          <WrapperCell
            key={`TimeOffCell-${column.headerCell}-${columnIndex}`}
            minWidth={column.minWidth}
          >
            <TimeOffCell
              date={column.date}
              leaves={leaves?.filterByDate(column.date)}
              restDays={restDays?.filterByDate(column.date)}
              loading={loading}
              onClick={() => handleClick(column.date)}
            />
          </WrapperCell>
        )
      })}

      {isSidePanelOpen && (
        <TimeOffSidepanel
          open={isSidePanelOpen}
          onClose={() => setIsSidePanelOpen(false)}
          selectedDate={selectedDate}
          leaves={leaves}
          restDays={restDays}
          holidays={holidays}
        />
      )}
    </>
  )
}

export default observer(TimeOffRow)
